module.exports = __webpack_public_path__ + "static/media/Decisions_Step1_Image26.ff5b3218.jpg";